import React from "react";
import { useEffect } from "react";
import './style.css' ;
import Home from "./pages/home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Silver from "./components/SilverSea";
// import Cruiselines from "./pages/CruiseLines";
import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min'; 
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Royal from "./components/RoyalCaribbean";
import Celebrity from "./components/Celebrity";
import Singapore from "./components/SingaporeCruise";
import CruiseDeal from "./pages/CruiseDeals";
import Destinations from "./pages/Destinations";
import AlreadyBooked from "./pages/AlreadyBooked";
import TermsCondition from "./pages/TermsConditions";
import CruiseFAQs from "./pages/CruiseFAQs";
import WhyCruise from "./pages/WhyCruise";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Azamara from "./components/Azamara";


function App() {
  
  useEffect(() => {
    require('bootstrap/dist/js/bootstrap.bundle.min.js');
  }, [])


  return (
    <>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/destinations" element={<Destinations/>} />
        {/* <Route path="/cruiselines" element={<Cruiselines />} /> */}
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/royalcaribbean" element={<Royal/>} />
        <Route path="/silversea" element={<Silver/>} />
        <Route path="/singapore" element={<Singapore/>} />
        <Route path="/celebritycruises" element={<Celebrity/>} />
        <Route path="/azamara" element={<Azamara/>} />
        <Route path="/cruisedeals" element={<CruiseDeal/>} />
        <Route path="/alreadybooked" element={<AlreadyBooked/>} />
        <Route path="/terms_and_conditions" element={<TermsCondition/>} />
        <Route path="/cancellation_policy" element={<TermsCondition/>} />
        <Route path="/privacy_policy" element={<PrivacyPolicy/> } />
        <Route path="/FAQs" element={<CruiseFAQs/>} />
        <Route path="/whycruise" element={<WhyCruise/>} />
      </Routes>
    </Router>
  
    </>
    
  );
}

export default App;
